import {appLocalStorage} from '../persistence';

class TenantId {
    readonly key = 'tenant_uuid';

    get(): string | undefined {
        return appLocalStorage.tenantUuid.get() ?? undefined;
    }

    set(uuid: string): void {
        appLocalStorage.tenantUuid.set(uuid);
    }

    remove(): void {
        appLocalStorage.tenantUuid.remove();
    }
}

export default TenantId;
